<template>
  <h4>
    {{amount}}
    <span>元</span>
  </h4>
</template>
<script>
export default {
  name: 'pay-fee-amount',
  data() {
    return {
      amount: ''
    }
  },
  created() {
    this.getFeeAmount()
  },
  methods: {
    getFeeAmount() {
      this.$fetch('/api/OrganizationEnterprise/GetPayAmount').then(result => {
        this.amount = result
      })
    }
  }
}
</script>

